// src/context/AccessContext.js
import React from 'react';

// Provider shape for Atlas ReX
// - user: full row from [user] table (all columns), or null when loading
// - availableRoutes: array of strings like ['home']
// - accessToken: AAD access token used for calling Azure Functions
const AccessContext = React.createContext({
  user: null,
  availableRoutes: null,
  accessToken: null,
});

export default AccessContext;
